import { render, staticRenderFns } from "./evaluaciones-individuales-2026.vue?vue&type=template&id=906494fc&scoped=true&"
import script from "./evaluaciones-individuales-2026.componet.ts?vue&type=script&lang=ts&"
export * from "./evaluaciones-individuales-2026.componet.ts?vue&type=script&lang=ts&"
import style0 from "./evaluaciones-individuales-2026.vue?vue&type=style&index=0&id=906494fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906494fc",
  null
  
)

export default component.exports